export default __webpack_public_path__ + "static/media/login-bg.b440fdf3.png";